/* Dirty Penny quick view shell (Figma 775:6209 / 775:6416).
   Opens from the product-card search chip ([data-dp-qv]). Content comes from
   the Section Rendering API ({product.url}?section_id=dp-quick-view), cached
   per product and prefetched on chip hover. The shell owns: backdrop, frame,
   close button, skeleton, open/close choreography, and all content behavior
   (thumbs, qty, variant chips, buy now, accordion). The bag button reuses the
   dp-cart quick-add pipeline (.dp-upsell-form + data-dp-open-cart); when the
   drawer opens after that add, the quick view closes itself. */
(function () {
  'use strict';
  if (window.__dpQuickView) return;
  window.__dpQuickView = 1;

  var SHELL_CSS = [
    '.dp-qv-shell,.dp-qv-shell *{border-radius:0!important;box-sizing:border-box}',
    '.dp-qv-shell{position:fixed;inset:0;z-index:85;display:flex;align-items:center;justify-content:center}',
    '.dp-qv-shell[hidden]{display:none}',
    '.dp-qv-backdrop{position:absolute;inset:0;background:rgba(34,27,18,.45);backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px);opacity:0;transition:opacity .3s ease}',
    '.dp-qv-shell.is-open .dp-qv-backdrop{opacity:1}',
    '.dp-qv-frame{position:relative;width:min(1030px,calc(100vw - 64px));height:min(681px,calc(100vh - 64px));background:#F4F0E3;box-shadow:0 24px 80px rgba(34,27,18,.35);opacity:0;transform:translateY(26px) scale(.965);transition:opacity .38s ease,transform .42s cubic-bezier(.22,.61,.36,1)}',
    '.dp-qv-shell.is-open .dp-qv-frame{opacity:1;transform:translateY(0) scale(1)}',
    '.dp-qv-shell.is-closing .dp-qv-backdrop{opacity:0}',
    '.dp-qv-shell.is-closing .dp-qv-frame{opacity:0;transform:translateY(14px) scale(.985);transition-duration:.24s,.24s}',
    '.dp-qv-x{position:absolute;top:16px;right:23px;z-index:5;width:40px;height:40px;display:flex;align-items:center;justify-content:center;background:#fff;color:#000;border:1.5px solid #000;cursor:pointer;padding:0;transition:background .2s ease,color .2s ease}',
    '@media (max-width:767px){.dp-qv-x{top:16px;right:16px}}',
    '.dp-qv-x:hover{background:#1f1f1f;color:#fff;border-color:#000}',
    '.dp-qv-x svg{width:16px;height:15px;display:block}',
    '.dp-qv-box{position:absolute;inset:0;overflow:hidden}',
    '.dp-qv-box>*{height:100%}',
    /* skeleton */
    '.dp-qv-skel{display:flex;height:100%}',
    '.dp-qv-skel-left{flex:1 1 auto;background:#F4F0E3;position:relative}',
    '.dp-qv-skel-right{flex:0 0 460px;background:#fff;padding:32px 24px;display:flex;flex-direction:column;gap:14px}',
    '.dp-qv-skel-bar{background:#ECE7DA;animation:dpQvPulse 1.1s ease-in-out infinite}',
    '@keyframes dpQvPulse{0%,100%{opacity:1}50%{opacity:.45}}',
    '@media (max-width:767px){',
    '.dp-qv-shell{align-items:flex-end}',
    '.dp-qv-frame{width:100vw;height:100dvh;max-height:100dvh;box-shadow:none;transform:translateY(100%);transition:transform .46s cubic-bezier(.22,.61,.36,1),opacity .3s ease}',
    '.dp-qv-shell.is-open .dp-qv-frame{transform:translateY(0)}',
    '.dp-qv-shell.is-closing .dp-qv-frame{transform:translateY(100%);opacity:1}',
    '.dp-qv-skel-right{flex:1 1 auto}',
    '}',
    'html.dp-qv-lock{overflow:hidden}'
  ].join('');

  var SKELETON =
    '<div class="dp-qv-skel">' +
    '<div class="dp-qv-skel-left"></div>' +
    '<div class="dp-qv-skel-right">' +
    '<div class="dp-qv-skel-bar" style="width:90px;height:18px"></div>' +
    '<div class="dp-qv-skel-bar" style="width:85%;height:30px"></div>' +
    '<div class="dp-qv-skel-bar" style="width:60%;height:30px"></div>' +
    '<div class="dp-qv-skel-bar" style="width:120px;height:18px;margin-top:10px"></div>' +
    '<div class="dp-qv-skel-bar" style="width:100%;height:90px;margin-top:16px"></div>' +
    '<div class="dp-qv-skel-bar" style="width:100%;height:60px;margin-top:auto"></div>' +
    '</div></div>';

  var shell = null, box = null, cache = {}, isOpen = false, lastFocus = null, addedHere = false;

  function ensureShell() {
    if (shell) return;
    var style = document.createElement('style');
    style.textContent = SHELL_CSS;
    document.head.appendChild(style);
    shell = document.createElement('div');
    shell.className = 'dp-qv-shell';
    shell.hidden = true;
    shell.innerHTML =
      '<div class="dp-qv-backdrop"></div>' +
      '<div class="dp-qv-frame" role="dialog" aria-modal="true" aria-label="Quick view">' +
      '<div class="dp-qv-box"></div>' +
      '<button class="dp-qv-x" type="button" aria-label="Close quick view">' +
      '<svg viewBox="0 0 16 15.2381" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.15681 7.61905L16 14.1364L14.8424 15.2381L8 8.72076L1.15681 15.2381L0 14.1364L6.8424 7.61905L0 1.10171L1.15681 0L8 6.51733L14.8424 0L16 1.10171L9.15681 7.61905Z" fill="currentColor"/></svg>' +
      '</button></div>';
    document.body.appendChild(shell);
    box = shell.querySelector('.dp-qv-box');
    shell.querySelector('.dp-qv-backdrop').addEventListener('click', close);
    shell.querySelector('.dp-qv-x').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) close();
      /* keep keyboard focus inside the dialog — same trap as the reviews
         modal; without it Tab walks into the blurred page behind */
      if (e.key === 'Tab' && isOpen) {
        var f = shell.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && (document.activeElement === last || !shell.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
      }
    });
    /* the bag add opens the drawer — get out of its way */
    document.addEventListener('eurus:cart:items-changed', function () {
      if (isOpen && addedHere) setTimeout(close, 250);
      addedHere = false;
    });
  }

  function load(url) {
    var key = url.split('?')[0];
    if (!cache[key]) {
      cache[key] = fetch(key + '?section_id=dp-quick-view', { headers: { Accept: 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); });
      cache[key].catch(function () { delete cache[key]; });
    }
    return cache[key];
  }

  function open(url) {
    ensureShell();
    lastFocus = document.activeElement;
    box.innerHTML = SKELETON;
    shell.hidden = false;
    shell.classList.remove('is-closing');
    isOpen = true;
    document.documentElement.classList.add('dp-qv-lock');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { shell.classList.add('is-open'); });
    });
    shell.querySelector('.dp-qv-x').focus({ preventScroll: true });
    load(url).then(function (html) {
      if (!isOpen) return;
      box.innerHTML = html;
      initContent(box);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { box.classList.add('is-ready'); });
      });
    }).catch(function () {
      /* graceful fallback: real product page */
      window.location.href = url;
    });
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    shell.classList.add('is-closing');
    shell.classList.remove('is-open');
    setTimeout(function () {
      shell.hidden = true;
      shell.classList.remove('is-closing');
      box.classList.remove('is-ready');
      box.innerHTML = '';
      document.documentElement.classList.remove('dp-qv-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }, 300);
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function initContent(scope) {
    var root = scope.querySelector('[data-dp-qv-root]');
    if (!root) return;
    var cfgEl = root.querySelector('[data-dp-qv-config]');
    var cfg = cfgEl ? JSON.parse(cfgEl.textContent) : { variants: [] };
    var qty = 1;
    var qtyEl = root.querySelector('[data-dp-qv-qty]');
    var formQty = root.querySelector('[data-dp-qv-formqty]');
    var idInput = root.querySelector('[data-dp-qv-id]');
    var priceEl = root.querySelector('[data-dp-qv-price]');
    var buyBtn = root.querySelector('[data-dp-qv-buynow]');
    var buyLabel = root.querySelector('[data-dp-qv-buynow-label]');
    var bagBtn = root.querySelector('.dp-qv-bag');
    var mainImg = root.querySelector('[data-dp-qv-main]');

    function currentVariant() {
      if (cfg.variants.length < 2) return cfg.variants[0] || null;
      var sel = [];
      root.querySelectorAll('[data-dp-qv-option]').forEach(function (row) {
        var on = row.querySelector('[aria-pressed="true"]');
        sel[parseInt(row.getAttribute('data-dp-qv-option'), 10)] = on ? on.getAttribute('data-dp-qv-value') : null;
      });
      return cfg.variants.find(function (v) {
        return (sel[0] == null || v.option1 === sel[0]) &&
               (sel[1] == null || v.option2 === sel[1]) &&
               (sel[2] == null || v.option3 === sel[2]);
      }) || null;
    }

    function applyVariant() {
      var v = currentVariant();
      var available = !!(v && v.available);
      if (v) {
        if (idInput) idInput.value = v.id;
        if (priceEl) {
          priceEl.innerHTML = (v.compare_at_price && v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + money(v.price);
        }
        if (buyLabel) buyLabel.textContent = available ? 'Buy now (' + money(v.price * qty) + ')' : 'Out of stock';
        if (v.featured_image && v.featured_image.src && mainImg) mainImg.src = v.featured_image.src;
      } else if (buyLabel) {
        buyLabel.textContent = 'Unavailable';
      }
      if (buyBtn) buyBtn.disabled = !available;
      if (bagBtn) bagBtn.disabled = !available;
    }

    /* qty stepper */
    var minus = root.querySelector('[data-dp-qv-minus]');
    var plus = root.querySelector('[data-dp-qv-plus]');
    function setQty(n) {
      qty = Math.max(1, Math.min(99, n));
      if (qtyEl) qtyEl.textContent = qty;
      if (formQty) formQty.value = qty;
      applyVariant();
    }
    if (minus) minus.addEventListener('click', function () { setQty(qty - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(qty + 1); });

    /* option chips */
    root.querySelectorAll('[data-dp-qv-option]').forEach(function (row) {
      row.addEventListener('click', function (e) {
        var chip = e.target.closest('.dp-qv-chip');
        if (!chip) return;
        row.querySelectorAll('.dp-qv-chip').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        chip.setAttribute('aria-pressed', 'true');
        applyVariant();
      });
    });

    /* thumbnails */
    root.querySelectorAll('[data-dp-qv-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('[data-dp-qv-thumb]').forEach(function (x) { x.classList.remove('is-current'); });
        t.classList.add('is-current');
        if (mainImg) {
          mainImg.style.opacity = '0';
          var src = t.getAttribute('data-dp-qv-thumb');
          var pre = new Image();
          pre.onload = function () { mainImg.src = src; mainImg.style.opacity = '1'; };
          pre.src = src;
        }
      });
    });

    /* description accordion + show more/less */
    var desc = root.querySelector('[data-dp-qv-desc]');
    if (desc) {
      desc.querySelector('.dp-qv-desc-head').addEventListener('click', function () {
        var openNow = desc.classList.toggle('is-open');
        this.setAttribute('aria-expanded', openNow ? 'true' : 'false');
      });
      var more = desc.querySelector('[data-dp-qv-more]');
      var body = desc.querySelector('.dp-qv-desc-body p');
      if (more && body) {
        /* nothing hidden by the 4-line clamp -> no toggle */
        requestAnimationFrame(function () {
          if (body.scrollHeight <= body.clientHeight + 4) more.style.display = 'none';
        });
        more.addEventListener('click', function () {
          /* cap the expanded body so the PANEL never grows a scrollbar: it
             may consume the flexible gap before the bottom-anchored
             controls (margin-top:auto), nothing more. Measure BEFORE
             toggling — mid-transition layout lies. */
          var bodyBox = desc.querySelector('.dp-qv-desc-body');
          var purchase = root.querySelector('.dp-qv-purchase');
          var expanding = !desc.classList.contains('is-expanded');
          if (expanding && bodyBox && purchase) {
            var freeGap = purchase.getBoundingClientRect().top - desc.getBoundingClientRect().bottom - 24;
            var room = bodyBox.offsetHeight + Math.max(0, freeGap);
            bodyBox.style.maxHeight = Math.max(100, room) + 'px';
          } else if (bodyBox) {
            bodyBox.style.maxHeight = '';
          }
          desc.classList.toggle('is-expanded', expanding);
          more.textContent = expanding ? 'Show less' : 'Show more';
        });
      }
    }

    /* buy now: add then straight to checkout */
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        var v = currentVariant();
        if (!v || !v.available || buyBtn.disabled) return;
        buyBtn.disabled = true;
        if (buyLabel) buyLabel.textContent = 'One moment…';
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: v.id, quantity: qty })
        }).then(function (r) { return r.json(); }).then(function () {
          window.location.href = '/checkout';
        }).catch(function () {
          buyBtn.disabled = false;
          applyVariant();
        });
      });
    }

    /* flag bag adds so the drawer-open closes us */
    var bagForm = root.querySelector('.dp-qv-bagform');
    if (bagForm) bagForm.addEventListener('submit', function () { addedHere = true; }, true);

    applyVariant();
  }

  /* triggers */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-dp-qv]');
    if (!t) return;
    e.preventDefault();
    open(t.getAttribute('data-dp-qv'));
  }, true);
  document.addEventListener('mouseover', function (e) {
    var t = e.target.closest && e.target.closest('[data-dp-qv]');
    if (t) load(t.getAttribute('data-dp-qv')); /* prefetch; cached per product */
  }, { passive: true });
})();
